import { Flame } from "lucide-react";

export function StreakBadge({ streak, activeToday, totalDays, completedDays = [] }) {
  const hot = streak > 0 && activeToday;
  return (
    <div className={`panel flex items-center gap-4 p-5 ${hot ? "border-orange-500/50 bg-orange-500/10" : ""}`} data-testid="streak-badge">
      <span className={`grid h-12 w-12 shrink-0 place-items-center rounded-full ${hot ? "bg-orange-500 text-slate-950" : "bg-slate-800 text-slate-400"}`}>
        <Flame size={24} strokeWidth={2.5} />
      </span>
      <div className="min-w-0 flex-1">
        <p className="eyebrow">{hot ? "Streak alive" : streak > 0 ? "Streak at risk" : "Start a streak"}</p>
        <p className="mt-0.5 font-display text-lg font-semibold" data-testid="streak-count">
          {streak === 0 ? "Play today to start" : `${streak} ${streak === 1 ? "day" : "days"} in a row`}
        </p>
        <div className="mt-2 flex gap-1" data-testid="streak-days">
          {Array.from({ length: totalDays }, (_, i) => i + 1).map((d) => (
            <span key={d} className={`h-1.5 flex-1 rounded-full ${completedDays.includes(d) ? "bg-orange-400" : "bg-slate-800"}`} />
          ))}
        </div>
      </div>
      {streak >= 3 && <span className="rounded-full bg-orange-500/20 px-2.5 py-1 font-mono text-xs font-bold text-orange-300" data-testid="streak-milestone">{streak >= totalDays ? "PERFECT SEASON" : streak >= 5 ? "ON FIRE" : "HOT"}</span>}
    </div>
  );
}
